<template>
<mm-table slot="dataTable" slot-scope="res" :res="res"  >
    <el-table-column label="EN" prop="en_name" />
    <el-table-column label="CN" prop="cn_name" />
    <el-table-column label="Code" prop="code" />
    <el-table-column label="Time Zone" prop="time_zone" />
</mm-table>
</template>

<script>
export default {
	data() {
		return {
            res:{rows:[]},
		};
    },
    beforeMount() {
        const country_arr = this.$countryCode;
        for(const country of country_arr) {
            this.res.rows.push({en_name:country[0],cn_name:country[1],code:country[2],time_zone:country[3]});
        }
    }

};
</script>

<style scoped>
.bt-create {
  position: relative;
  right: 0px;
}
</style>
